var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { renderIcon } from '../../utils';
export var DatePicker = function (_a) {
    var label = _a.label, hideCalendarIcon = _a.hideCalendarIcon, props = __rest(_a, ["label", "hideCalendarIcon"]);
    return (_jsxs(_Fragment, { children: [label && (_jsx("label", __assign({ className: " text-textDark mb-2 font-semibold" }, { children: label }))), _jsxs("div", __assign({ className: "bg-uiBg relative z-20 w-full rounded-md p-1" }, { children: [_jsx(ReactDatePicker, __assign({ className: "text-textDark relative z-10 w-full rounded-md border-0 bg-transparent", wrapperClassName: "w-full" }, props)), !hideCalendarIcon &&
                        renderIcon('CalendarIcon', 'absolute z-0 text-primary top-3 right-4 w-6 h-6')] }))] }));
};
//# sourceMappingURL=index.js.map